module.exports = __webpack_public_path__ + "static/media/sal.d52eebf4.svg";